import { formatDate } from "../services/receipt.service";
import {
    buildDocDefinition, openPdf, headerRow, dataRow, totalRow, emptyRow,
    fmtLongDate, fmtAmount, fmtINR, sumBy,
} from "./reportTheme";

export const DailyReportPrint = async (selectedDate, logoBase64, dailyReportList = []) => {
    const grandTotal = sumBy(dailyReportList, "totalAmount");

    const body = [
        headerRow("Amount (₹)"),
        ...dailyReportList.map((item, i) => dataRow(item, i, fmtAmount(item.totalAmount), formatDate)),
    ];
    body.push(
        dailyReportList.length
            ? totalRow("Grand Total", fmtINR(grandTotal), { grand: true })
            : emptyRow()
    );

    return openPdf(
        buildDocDefinition({
            logoBase64,
            title: "Daily Seva List",
            summary: [
                { label: "Date", value: fmtLongDate(selectedDate) },
                { label: "Total Receipts", value: dailyReportList.length },
                { label: "Total Collection", value: fmtINR(grandTotal), accent: true },
            ],
            body,
        })
    );
};

export default DailyReportPrint;